import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      meta: { title: '首页' },
      component: resolve => require(['../components/common/Home.vue'], resolve),
      children:[
        {
          path:'/index',
          component: resolve => require(['../components/main/blog/index.vue'], resolve),
          meta:{title:"文章管理"}
        },
        {
          path:'/article',
          component: resolve => require(['../components/main/blog/article.vue'], resolve),
          meta:{title:"博客添加"}
        },
        {
          path:'/comments',
          component: resolve => require(['../components/main/blog/comments.vue'], resolve),
          meta:{title:"评论管理"}
        },
        {
          path:'/label',
          component: resolve => require(['../components/main/blog/label.vue'], resolve),
          meta:{title:"标签管理"}
        },
        // 系统
        {
          path:'/menu',
          component: resolve => require(['../components/main/system/menu.vue'], resolve),
          meta:{title:"菜单管理"}
        },
        // 微信
      ]
    },
    {
      path: '/login',
      component: resolve => require(['../components/main/Login.vue'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js